import React, { Component } from 'react'
import './input.css'

class SelectIDInput extends Component {
    state = {
        focused: false
    };

    handleChange = (e) => {
        this.props.onChange && this.props.onChange(e);
    }
    setFocused = (e) => {
        this.setState({ focused: true });
    }
    setBlure = (e) => {
        this.setState({ focused: false });
    }
    render() {
        let { error, value, name, label, options } = this.props;
        error = error === undefined ? '' : error;
        value = value === undefined ? '' : value;
        return (
            <div className="MuiFormControl-root MuiTextField-root">
                {label !== null && <label className={`MuiFormLabel-root MuiInputLabel-root MuiInputLabel-formControl MuiInputLabel-animated Mui-focused MuiInputLabel-shrink ${error !== '' && this.state.focused ? 'Mui-error' : ''}`} htmlFor={name}>{label}</label>}
                <div className={`MuiInputBase-root MuiInput-root MuiInput-underline MuiInputBase-formControl MuiInput-formControl ${this.state.focused ? "Mui-focused" : ""} ${error !== '' ? 'Mui-error' : ''}`}>
                    <select style={{textTransform: 'capitalize'}} name={name} value={value} className="MuiInputBase-input MuiInput-input w-100" onFocus={(e) => { this.setFocused(e) }} onBlur={(e) => { this.setBlure(e) }} onChange={(e) => this.handleChange(e)} {...this.props}>
                        <option selected value=''> -- select {label} -- </option>
						{options.map( (option, i) =>
							<option key={`op${i}ton`} value={option.id}>{option.name}</option>
						)}
					</select>
                </div>
                {error !== '' && <p className="MuiFormHelperText-root Mui-error MuiFormHelperText-filled">{error}</p>}
            </div>
        );
    }
}

export default SelectIDInput;